import { Container, Row, Col, ListGroup, Table, Button, Modal, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Actions from "../redux/actions";

import API from '../api/api'
export default function PhishingUrls(props) {

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const phishingUrls = useSelector(state => state.phishingUrls)
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()


    useEffect(() => {
        if (!phishingUrls) {
            _setup()
        } else {
            setLoading(false)

        }
        document.title = 'ScamWall | Phishing Urls'

    }, [])

    const _setup = async () => {
        dispatch(Actions.setPhishingUrls(await API.getPhishingUrls()))
        setLoading(false)
    }

    return (
        <Container fluid className='pt-4 ps-4 m-0'>

            <h1 className='text-start'>Phishing URLs</h1>
            <p className='text-start'>If a link got blocked for phishing, you can override it here</p>
            <Row className='justify-content-center'>
                <Col md={11}>
                    <Table striped responsive className='border rounded '>
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Link</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        {!loading && phishingUrls && user &&  <tbody>
                            {phishingUrls?.map(block => {
                                var name = ''
                                if (block?.userId === user?._id) {
                                    name = 'YOUR ACCOUNT'
                                } else {
                                    const found = accounts?.find(user => user._id === block.userId)
                                    name = `${found.fName} ${found.lName}`
                                }
                                return (
                                    <tr key={block._id}>
                                        <td className='vertical-table'>{name}</td>
                                        <td className='vertical-table'>{block.url.slice(0, Math.floor(block.url.length / 2))} <span className='text-primary'><b>...</b></span></td>
                                        <td className='vertical-table'>{new Date(block.createdAt).toLocaleString('en-US', { timeStyle: 'short', dateStyle: 'short' })}</td>
                                        <td className='vertical-table'><Link variant='primary' to={`/phishing/${block._id}`}>View</Link></td>
                                    </tr>)
                            })}
                        </tbody>}

                    </Table >
                    {loading && <div className='text-center my-3'><Spinner animation='border' /></div>}
                    {phishingUrls?.length === 0 && !loading && <p className='text-center'>No emails have been blocked yet. That's a good thing!</p>}
                </Col>
            </Row>


        </Container >
    )
}